export const olt_solt33_08p = {
    meta_title: "GPON OLT for Fiber Access Networks | Niurix SOLT33-08P",
    meta_description:
        "Niurix SOLT33-08P is a GPON OLT designed for centralized fiber access across hospitality, residential, and workspace environments.",

    section1: {
        background_img: "SOLT33-08P banner",
        background_img_mobile: "Group 168215",
    },

    section2: {
        mainHeading: `<span>Our</span> Product (OLTs)`,
        subHeading: "Niurix SOLT33-08P",
        mainPara: "",
        para: `<p>The Niurix SOLT33-08P is an Optical Line Terminal (OLT) designed for GPON networks serving up to 128 Optical Network Terminals (ONTs) per PON port. It consists of eight GPON ports, 4 GE Optical/Electrical uplink ports, along with two 10 Gigabit Ethernet (10GE) uplink ports.\n\nThe higher data throughput in SOLT33-08P serves as a critical component in delivering high-speed internet and other services to end-users. The device has a sleek, compact wall-mount design and can predetermine the simultaneous data management helping you better align your resources to cater to the needs of the OLT.</p>`,
        background_img1: "Overview background",
        background_img1_mobile: "Product Solt 08 backg",
    },
    section3: {
        mainHeading: `<span>Connect</span> Effortlessly, Anytime, <span>Anywhere!</span>`,
        // subHeading1: "subheading1",
        para1: `<p>The compact size makes it compatible for small to medium-sized businesses or deployments and multi-dwelling units (MDUs). The availability of 8 GPON ports makes SOLT33-08P more practical consuming lesser power. It also has a full-fledged carrier-class reliability with a complete set of security features.\n\nThe Niurix SOLT33-08P is widely used to cater to the custom requirements of LCOs (Local Cable Operators) and ISPs (Internet Service Providers) due to its flexible features and QoS features.</p>`,
        subHeading2: "The Twist Towards Simpler Connectivity",
        para2: `<ul><li>4 Ethernet port</li><li>1 GPON Uplink Port</li><li>... etc. ...</li></ul>`,
        background_img: "Component solt33-8p",
    },
    section4: {
        background_img: "Detail",
        background_img_mobile: "details 8 p",

        title: "The Twist Towards Simpler Connectivity",
        text_content_groups: [
            {
                title: "Compact Design",
                para: "Their compact design is beneficial for saving space for optimizing installation and deployment flexibility.",
            },
            {
                title: "Wall/rack-mountable",
                para: "They can be conveniently mounted on walls or racks, adapting to various network infrastructure designs.",
            },
            {
                title: "Low Power Consumption",
                para: "Their energy-efficient design contributes to enhanced cost savings and environmental sustainability.",
            },
        ],
    },
    section5: [
        {
            title: "General Product Specifications of Saturn SOLT33-08P OLT ",
            specifications: "Specification",
            dimension: "Dimensions",
            specification: [
                {
                    title: "GPON Uplink Ports",
                    value: "08",
                },
                {
                    title: "GE Ethernet Ports",
                    value: "04",
                },
                {
                    title: "Analog Phone Ports",
                    value: "None",
                },
                {
                    title: "CATV Ports",
                    value: "None",
                },
                {
                    title: "Power Supply",
                    value: "AC : 90 - 264 V, 47/63 Hz , DC : 36 - 72 V",
                },
                {
                    title: "Power Consumption",
                    value: "50 Watts",
                },
            ],
            dimensions: [
                {
                    title: "Length",
                    value: "445mm",
                },
                {
                    title: "Width",
                    value: "227mm",
                },
                {
                    title: "Height",
                    value: "44mm",
                },
                {
                    title: "Weight",
                    value: "⩽ 2.8kg",
                },
            ],
            para: "Click to download the full specifications",
            pdf: "NiurixSOLT33-08POLT",
        },
    ],
    swiper: [
        {
            img: "Spec 1",
        },
        {
            img: "Spec 2",
        },
        {
            img: "Spec 3",
        },
        {
            img: "Spec 4",
        },
    ],
    swipper: {
        img1: "Spec 1",
        img2: "Spec 2",
        img3: "Spec 3",
        img4: "Spec 4",
    },
    section6: {
        video: "Video",
    },
    section7: {
        background_img: "contact banner",
        title: "section5",
    },
};
